<template>
    <li class="case-card">
        <a :href="caseItem.Url" class="case-card__inner">
            <ResponsiveImage v-if="caseItem.Image" wrapperClass="case-card__image" :imageModel="caseItem.Image" />

            <div class="case-card__image" v-if="!caseItem.Image">
                <div class="image-cover-wrap">
                    <picture>
                        <img class="image-cover lazyload" width="620" height="380" src="/assets/images/placeholders/case_card_placeholder.png" alt="" />
                    </picture>
                </div>
            </div>

            <p class="case-card__tag">
                {{caseItem.CustomerName}}
            </p>
            <p class="case-card__name">
                {{caseItem.Name}}
            </p>
        </a>
    </li>
</template>

<script>
import ResponsiveImage from "./responsiveImage.vue";

    export default {
        name: "caseItem",
        props: ["caseItem"],
        components:{
            ResponsiveImage
        }
    };
</script>